import CourseList from "../components/pages/CourseList";
import Course from "../components/pages/Course";
import SessionRegister from "../components/pages/SessionRegister";
import RegisterAccountType from '../components/register/steps/AccountType';
import RegisterAccount from '../components/register/steps/Account';
import RegisterRegistrants from '../components/register/steps/Registrants';
import RegisterOptions from '../components/register/steps/Options';
import RegisterForm from '../components/register/steps/Form';
import RegisterPrices from '../components/register/steps/Prices';
import RegisterMeals from '../components/register/steps/Meals';
import RegisterCheckout from '../components/register/steps/Checkout';
import RegisterSummary from '../components/register/steps/Summary';
import RegisterConfirmation from '../components/register/steps/Confirmation';
import ConfirmationForm from "../components/register/steps/ConfirmationForm";
import PageNotFound from '../components/pages/PageNotFound';

export default [
    {
        name: 'list',
        path: '/',
        component: CourseList,
    },
    {
        name: 'course',
        path: '/fiche/:courseId',
        component: Course
    },
    {
        path: '/fiche/:courseId/session/:sessionId/inscription',
        alias: '/fiche/:courseId/session/:sessionId/confirmation',
        component: SessionRegister,
        children: [
            {
                path: '',
                name: 'session-register',
                component: RegisterAccountType,
                // component: RegisterAccount,
            },
            {
                path: ':orderId',
                name: 'register-order',
                // redirects to step
            },
            {
                path: ':orderId/type',
                name: 'register-account-type',
                component: RegisterAccountType,
            },
            {
                path: ':orderId/compte',
                name: 'register-account',
                component: RegisterAccount,
            },
            {
                path: ':orderId/inscrits',
                name: 'register-registrants',
                component: RegisterRegistrants,
            },
            {
                path: ':orderId/options',
                name: 'register-options',
                component: RegisterOptions,
            },
            {
                path: ':orderId/formulaire',
                name: 'register-form',
                component: RegisterForm,
            },
            {
                path: ':orderId/formulaire-confirmation',
                name: 'confirmation-form',
                component: ConfirmationForm,
            },
            {
                path: ':orderId/tarifs',
                name: 'register-prices',
                component: RegisterPrices,
            },
            {
                path: ':orderId/repas',
                name: 'register-meals',
                component: RegisterMeals,
            },
            {
                path: ':orderId/paiement',
                name: 'register-checkout',
                component: RegisterCheckout,
            },
            {
                path: ':orderId/recapitulatif',
                name: 'register-summary',
                component: RegisterSummary,
            },
            {
                path: ':orderId/confirmation',
                name: 'register-confirmation',
                component: RegisterConfirmation,
            }
        ]
    },
    {
        path: '*',
        component: PageNotFound,
    },
]
